export default class Langs{
    constructor(){
        this.langs = document.querySelector('.header-desktop .langs');
        if (this.langs){
            this.btn = this.langs.querySelector('.langs__btn');
            this.langsDropdown();
        }
    }

    langsDropdown() {
        this.btn.addEventListener('click', () => {
            this.langs.classList.toggle('active');
        });

    }
}